import React from "react";
import { Sparkles, Trash2 } from "lucide-react";
import { MuteMenu, muteLabel } from "./MuteMenu";

const tone = ({ isMe, isAI, isTeacher }) => {
  if (isMe) return "border-cyan-400/40 bg-cyan-500/10 text-cyan-100";
  if (isAI) return "border-fuchsia-400/40 bg-fuchsia-500/10 text-fuchsia-100";
  if (isTeacher) return "border-amber-400/40 bg-amber-500/5 text-amber-100";
  return "border-white/10 bg-white/5 text-slate-100";
};

export function ChatMessage({ m, me, muteRec, onDelete, onMute, onUnmute }) {
  const isMe = m.user_id === me.id;
  const canModerate = me.role === "teacher" && !m.is_ai;
  return (
    <div className={`flex ${isMe ? "justify-end" : "justify-start"}`} data-testid={`chat-msg-${m.id}`}>
      <div className={`group max-w-[88%] rounded-md sm:max-w-[80%] border px-4 py-2 text-sm ${tone({ isMe, isAI: m.is_ai, isTeacher: m.role === "teacher" })}`}>
        <div className="mb-1 flex items-center gap-2 text-[10px] uppercase tracking-widest opacity-70">
          {m.is_ai && <Sparkles size={10} />}
          <span>
            {m.name}
            {muteRec && <span className="ml-1 text-red-300" data-testid={`mute-label-${m.user_id}`}>· {muteLabel(muteRec)}</span>}
          </span>
          <span>· {new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
          {canModerate && (
            <span className="ml-auto flex gap-1 opacity-0 transition-opacity group-hover:opacity-100 focus-within:opacity-100 [@media(hover:none)]:opacity-100 [&:has([aria-expanded=true])]:opacity-100">
              {m.role === "student" && <MuteMenu userId={m.user_id} mute={muteRec} onMute={onMute} onUnmute={onUnmute} />}
              <button onClick={() => onDelete(m.id)} data-testid={`mod-delete-${m.id}`} title="Delete" className="icon-btn rounded p-1.5 sm:p-0.5 hover:bg-red-500/20 hover:text-red-300">
                <Trash2 size={10} />
              </button>
            </span>
          )}
        </div>
        <div className="whitespace-pre-wrap">{m.content}</div>
      </div>
    </div>
  );
}
